import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";

import { login } from '@/actions/auth'
import Button from 'shared/Button';
import Translation from '@s/Translation';

class FanaticsSSO extends Component {

    state = {
        fanaticsWindow: null
    }

    onMessage = (e) => {
        if ((!e.data) || (e.origin !== this.props.ui.styleVars.GLOBAL__PARTNER__URL)) return;

        let data;
        try {
            data = JSON.parse(e.data);
        } catch {
            return;
        }
        if (data?.ssoResult?.verify) {
            if (this.state.fanaticsWindow) {
                this.state.fanaticsWindow.close();
            }
            this.props.handleEmailVerification();
            return false;
        } else if (data?.ssoResult?.success) {
            this.props.login(data.ssoResult.email, data.ssoResult.first_name ?? '', data.ssoResult.last_name ?? '');
            this.props.handleSSOLoading();
            if (this.state.fanaticsWindow) {
                this.state.fanaticsWindow.close();
            }

            // Transition
            if (this.props.token) {
              this.props.navigate(`/checkout/${this.props.token}`);
            } else {
              this.props.navigate('/');
            }
        }
        else {
            if (this.state.fanaticsWindow) {
                this.state.fanaticsWindow.close();
            }
            this.props.handleSSOError();
        }
    };

    componentDidMount() {
        window.addEventListener('message', this.onMessage);
    }

    ssoClick = () => {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;

        const width = Math.min(400, screenWidth * 0.9);
        const height = Math.min(500, screenHeight * 0.9);

        const left = (screen.width / 2) - (width / 2);
        const top = (screen.height / 2) - (height / 2);
        const features = `height=${height},width=${width},left=${left},top=${top},` +
            `resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no,status=yes`;
        const url = this.props.ui.styleVars.GLOBAL__PARTNER__URL + '/sso/fanatics/login?state=checkout0' + Math.random().toString(36).substring(2)
            + '&listing_slug=' + encodeURI(this.props.listingSlug);

        const fanaticsWindow = window.open(url, 'popUpWindow', features);
        this.setState({ fanaticsWindow: fanaticsWindow });
    }

    render() {
        return (
            <Button onClick={this.ssoClick} className='button--secondary button--sso'>
                <Translation>{'checkout__continue_with'}</Translation> Fanatics
            </Button>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        listingSlug: state.ui.listingSlug,
        token: state.reservation.token,
        ui: state.ui
    }
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    login,
  }, dispatch);
};

FanaticsSSO.propTypes = {
  handleEmailVerification: PropTypes.func.isRequired,
  handleSSOLoading: PropTypes.func.isRequired,
  handleSSOError: PropTypes.func.isRequired,
  listingSlug: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  ui: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(FanaticsSSO)
